import React, { FC } from 'react';
import { Box, LinearProgress } from '@mui/material';

const Loader: FC = () => {
    return (
        <Box display="flex" alignItems="center" justifyContent="center" sx={{ width: '100%', height: 200 }}>
            <Box sx={{ width: '100%' }}>
                <LinearProgress color="secondary" />
            </Box>
        </Box>
    );
};

export default Loader;
